import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Typography } from "antd";

import styles from "./Spine.module.css";

const { Text } = Typography;

const ACCENT_ICON = {
  added: PlusCircleOutlined,
  removed: MinusCircleOutlined,
};

const ACCENT_TITLE = {
  added: "Adding",
  removed: "Removing",
};

// Structural primitives shared by every screen that renders a topic/subtopic
// spine (Plan, Recalibration, the roadmap calibration surface). Only the look
// is shared here.

export const Spine = ({ children, className = "" }) => (
  <div className={`${styles.spine} ${className}`}>{children}</div>
);

export const TopicGroup = ({ children, className = "" }) => (
  <div className={`${styles.topicGroup} ${className}`}>{children}</div>
);

export const TopicHeader = ({ children, className = "" }) => (
  <div className={`${styles.topicHeader} ${className}`}>{children}</div>
);

export const TopicName = ({ children, className = "" }) => (
  <Text className={`${styles.topicName} ${className}`}>{children}</Text>
);

export const SubtopicList = ({ children, className = "" }) => (
  <div className={`${styles.subtopicList} ${className}`}>{children}</div>
);

// Slots: `leading` (marker/icon), `children` (the name node), `secondary`
// (an optional second line under the name) and `trailing` (anything after
// the name column, before the accent icon). `accent` ("added" | "removed")
// selects the shared left-border color and renders the matching +/- icon --
// one definition, so every screen's marks mean the same thing. The row
// always reserves a transparent 3px border-left so `accent` only ever needs
// to set border-left-color, never the width alongside a screen-local
// border-left shorthand (that ordering would be a CSS-module import-order
// footgun). Extra props (e.g. `data-*`) pass through to the row.
export const SubtopicRow = ({
  rowRef,
  leading,
  secondary,
  trailing,
  accent,
  className = "",
  children,
  ...rest
}) => {
  const AccentIcon = ACCENT_ICON[accent];

  return (
    <div
      ref={rowRef}
      className={`${styles.subtopicRow} ${accent ? styles[`accent-${accent}`] : ""} ${className}`}
      {...rest}
    >
      {leading}
      <div className={styles.subtopicMain}>
        {children}
        {secondary}
      </div>
      {trailing}
      {AccentIcon && (
        <AccentIcon
          className={`${styles.diffIcon} ${styles[`accent-${accent}`]}`}
          title={ACCENT_TITLE[accent]}
        />
      )}
    </div>
  );
};

export const Marker = ({ className = "" }) => (
  <span className={`${styles.marker} ${className}`} />
);

export const NotInPlanMarker = ({ className = "" }) => (
  <span className={`${styles.notInPlanMarker} ${className}`}>–</span>
);

export const spineStyles = styles;
